var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "4 4 16 16",
    enableBackground: "new 4 4 16 16",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#231F20",
    d: "M12,4c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8c4.42,0,8-3.582,8-8C20,7.582,16.42,4,12,4z M16.95,16.949 C15.682,18.217,13.935,19,12,19s-3.681-0.783-4.949-2.051S5,13.934,5,12c0-1.935,0.783-3.681,2.051-4.95C8.319,5.783,10.065,5,12,5 s3.682,0.783,4.95,2.05C18.218,8.319,19,10.065,19,12C19,13.934,18.218,15.682,16.95,16.949z"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#231F20",
    cx: 12,
    cy: 8,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 10,
    fill: "#231F20",
    width: 1.5,
    height: 7
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltip);
export default __webpack_public_path__ + "static/media/tooltip.cb1e39d5dfea1a1235540e4df59a7a1b.svg";
export { ForwardRef as ReactComponent };